import Tooltip from 'antd/es/tooltip';
import styled from 'styled-components';

export const FeeDetailsTooltip = styled(Tooltip)``;

export const FeeDetailsButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin-top: 2px;
  cursor: pointer;
  text-decoration: underline;
`;

export const FeeDetailsButtonLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-left: 5px;
`;

export const FeeDetailsItem = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 10px;
  line-height: 2;
  color: ${({ theme }) => theme.palette.white};
`;

export const FeeDetailsDueHotelLabel = styled.span`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 10px;
  line-height: 2;
  color: ${({ theme }) => theme.palette.white};
`;
